/**
 * Filters EMT content metadata to remove null, undefined, and empty string values.
 *
 * This filtering is necessary because if null is explicitly passed through to metadata
 * tags, it could negate or override existing metadata values. By removing falsy values,
 * we ensure only valid metadata overrides are applied.
 *
 * @param {Object} emtContentMetadata - The EMT content metadata object to filter
 * @returns {Object} A new object containing only non-null, non-undefined, and non-empty metadata values
 *
 * @example
 * const metadata = { title: 'New Title', metaDescription: null, ogTitle: '' };
 * const filtered = filterEmtMetadataOverrides(metadata);
 * // Returns: { title: 'New Title' }
 */
export const filterEmtMetadataOverrides = (emtContentMetadata = {}) => {
  const overrides = {};

  Object.entries(emtContentMetadata).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== '') {
      overrides[key] = value;
    }
  });

  return overrides;
};
